import Vue from "vue";
import VueRouter from "vue-router";
import { authGuard } from "../auth/authGuard";

// Layouts
Vue.component("layout-default", () => import("@/layouts/default"));
Vue.component("layout-admin", () => import("@/layouts/admin"));
// const DefaultLayout = () => import("@/layouts/default");
// const AdminLayout = () => import("@/layouts/admin");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: {
      name: "missions",
    },
    meta: {
      public: true,
    },
  },
  // {
  //   path: "",
  //   meta: {
  //     layout: DefaultLayout,
  //   },
  //   children: [
  //     {
  //       path: "/login",
  //       name: "login",
  //       // route level code-splitting
  //       // this generates a separate chunk (about.[hash].js) for this route
  //       // which is lazy-loaded when the route is visited.
  //       component: () => import("@/pages/login"),
  //       meta: {
  //         public: true,
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   meta: {
  //     layout: AdminLayout,
  //   },
  //   children: [
  //     {
  //       path: "/missions",
  //       name: "missions",
  //       component: () => import("@/pages/missions"),
  //       beforeEnter: authGuard,
  //     },
  //     {
  //       path: "/missions/:id",
  //       name: "missions-id",
  //       component: () => import("@/pages/missions/_id"),
  //       beforeEnter: authGuard,
  //     },
  //     {
  //       path: "/assets",
  //       name: "assets",
  //       component: () => import("@/pages/assets"),
  //       beforeEnter: authGuard,
  //     },
  //     {
  //       path: "/configuration",
  //       name: "System",
  //       component: () => import("@/pages/configuration"),
  //       beforeEnter: authGuard,
  //     },
  //   ],
  // },
  {
    path: "/login",
    name: "login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("@/pages/login"),
  },
  {
    path: "/missions",
    name: "missions",
    component: () => import("@/pages/missions"),
    beforeEnter: authGuard,
    meta: {
      layout: "layout-admin",
    },
  },
  {
    path: "/missions/:id",
    name: "missions-id",
    component: () => import("@/pages/missions/_id"),
    beforeEnter: authGuard,
    meta: {
      layout: "layout-admin",
    },
  },
  {
    path: "/assets",
    name: "assets",
    component: () => import("@/pages/assets"),
    beforeEnter: authGuard,
    meta: {
      layout: "layout-admin",
    },
    props: true,
  },
  {
    path: "/assets-mapbox",
    name: "assets-mapbox",
    component: () => import("@/pages/assets-mapbox"),
    beforeEnter: authGuard,
    meta: {
      layout: "layout-admin",
    },
  },
  {
    path: "/configuration",
    name: "System",
    component: () => import("@/pages/configuration"),
    beforeEnter: authGuard,
    meta: {
      layout: "layout-admin",
    },
  },
  {
    path: "/contracts-users",
    name: "contracts-users",
    component: () => import("@/pages/contracts-users"),
    beforeEnter: authGuard,
    meta: {
      layout: "layout-admin",
    },
  },
  {
    path: "/config",
    name: "config",
    component: () => import("@/pages/config"),
    beforeEnter: authGuard,
    meta: {
      layout: "layout-admin",
    },
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("@/pages/profile"),
    beforeEnter: authGuard,
    meta: {
      layout: "layout-admin",
    },
  },
  {
    path: "/errors/account_configuration",
    name: 'errors.account_configuration',
    component: () => import('@/pages/errors/account_configuration'),
    meta: {
      layout: "layout-admin",
    },
  },
  {
    path: "*",
    redirect: {
      path: "/",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  // base: process.env.BASE_URL,
  routes,
});

/*
router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.public) {
    next();
  } else {
    if (StormportAuthUtil.getToken()) {
      // Fetch updated user data
      try {
        await store.dispatch("auth/fetchUser");
        // Fetch initial config
        if (!store.state.config.config) {
          await store.dispatch("config/fetchConfig"); 
        }
        next();
      } catch (err) {
        StormportAuthUtil.removeToken();
        next("/");
      }
    } else {
      next("/");
    }
  }
});
*/

export default router;
